<div class="configuration-summary">
  <div class="summary-item" nz-typography>
    <span class="label">Configuration</span>
    @if (isManualSizing()) {
      <span class="value">
        <span>{{ batteryName() }}</span>
        <span>|</span>
        <span>Config: {{ manualConfigNumber() }}</span>
        <span>|</span>
        <span>Strings: {{ manualStrings() }}</span>
        <span>|</span>
        <span>Quantity: {{ manualQuantity() }}</span>
        <span>|</span>
        <span>Total: {{ manualTotal() }}</span>
      </span>
    } @else {
      <span class="value">
        <span>{{ rangeLabel() }}</span>
        <span>|</span>
        <span>{{ batteryName() }}</span>
        <span>|</span>
        <span>{{ parallelSeries() }}</span>
        <span>|</span>
        <span>{{ c10OutputLabelAh() }} Ah</span>
        <span>|</span>
        <span>{{ realBackupMinutes() }} min</span>
      </span>
    }
  </div>
</div>
